import { StepperAssignmentURLSteps } from '~app/shared/enums/stepper-assignment-urls-steps.constant';
import { IStepperProcessSteps } from '../interfaces/process-step.interface';

export const CHECKIN_STEPS: IStepperProcessSteps = {
  [StepperAssignmentURLSteps.EMERGENCY_CONTACT]: {
    progress: {
      isContractor: 20,
      isCrewMember: 15,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.IDLE,
      next: StepperAssignmentURLSteps.BENEFICIARY_CONTACT,
    },
  },
  [StepperAssignmentURLSteps.BENEFICIARY_CONTACT]: {
    progress: {
      isContractor: 40,
      isCrewMember: 30,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.EMERGENCY_CONTACT,
      next: StepperAssignmentURLSteps.POLICIES,
    },
  },
  [StepperAssignmentURLSteps.POLICIES]: {
    progress: {
      isContractor: 60,
      isCrewMember: 45,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.BENEFICIARY_CONTACT,
      next: (isContractor: boolean) =>
        isContractor ? StepperAssignmentURLSteps.CUSTOMS : StepperAssignmentURLSteps.FINANCE,
    },
  },
  [StepperAssignmentURLSteps.FINANCE]: {
    progress: {
      isCrewMember: 60,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.POLICIES,
      next: StepperAssignmentURLSteps.CUSTOMS,
    },
  },
  [StepperAssignmentURLSteps.CUSTOMS]: {
    progress: {
      isContractor: 100,
      isCrewMember: 75,
    },
    redirections: {
      previous: (isContractor: boolean) =>
        isContractor ? StepperAssignmentURLSteps.POLICIES : StepperAssignmentURLSteps.FINANCE,
      next: (isContractor: boolean) => (isContractor ? StepperAssignmentURLSteps.IDLE : StepperAssignmentURLSteps.SOEA),
    },
  },
  /*[StepperAssignmentURLSteps.VACCINATION]: {
    progress: {
      isContractor: 100,
      isCrewMember: 90,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.CUSTOMS,
      next: (isContractor: boolean) => (isContractor ? StepperAssignmentURLSteps.IDLE : StepperAssignmentURLSteps.SOEA),
    },
  },*/
  [StepperAssignmentURLSteps.SOEA]: {
    progress: {
      isCrewMember: 100,
    },
    redirections: {
      previous: StepperAssignmentURLSteps.CUSTOMS,
      next: StepperAssignmentURLSteps.IDLE,
    },
  },
};
